var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('Header',{attrs:{"title":"Quck Start"}}),_c('v-row',{attrs:{"dense":""}},_vm._l((_vm.quickstarts),function(quickstart,i){return _c('v-col',{key:i,attrs:{"cols":"12","sm":"4"}},[_c('QuickStartCard',{attrs:{"title":quickstart.title,"steps":quickstart.steps}})],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }